// This file was automatically generated from uiwidget.alert.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.alert');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.alert.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="alert-ui" class="el8PromptDialog ebs-container-fluid"><div class="alert-title el8PromptDialogTitle"></div><div class="el8PromptDialogContainer"><p id="alert-message" data-dd-privacy="allow" class="el8PromptDialogText el8Preserve padh15"></p></div><div class="el8PromptDialogButtonSection"><ul class="el8ButtonContainer ebs-list-horizontal"><li class="el8DialogButtonItem"><button type="button" value="yes" class="el8button alert-yes-btn el8AlertButton ebs-btn ebs-btn-primary" data-testid="el8-alert-yes-button" tabindex="1"></button></li><li class="el8DialogButtonItem"><button type="button" value="no" class="el8button alert-no-btn el8AlertSecondaryButton ebs-btn ebs-btn-default" data-testid="el8-alert-no-button" tabindex="2"></button></li><li class="el8DialogButtonItem"><button type="button" class="el8button alert-custom-btn el8AlertSecondaryButton ebs-btn ebs-btn-default" tabindex="3" style="display: none"></button></li></ul></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.alert.title = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h1 class="el8AttentionText">', soy.$$escapeHtml(opt_data.title), '</h1>');
  if (!opt_sb) return output.toString();
};
